import React, { useContext, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AutoComplete } from 'components/Form'
import { getTestTakersOptionsFetch } from 'store/middlewares/testTakers.crud'
import { useSelector } from 'react-redux'
import { convertSelectToValue } from 'utils/formatter'
import { AbilityContext } from 'components/Permissions/Can'
import { features } from 'keys'
import qc from 'keys/queryClient'

const FilterTestTakers = (props) => {
    const [searchTxt, setSearchTxt] = useState("")

    const { headerFilters } = useSelector(state => state.header)

    const ability = useContext(AbilityContext)
    const canReadTestTaker = ability.can('read', features.test_taker)

    const testTakers = useQuery({
        queryKey: [qc.testTakers, "header-pulldown", searchTxt, headerFilters.group, headerFilters.affiliation, headerFilters.grade, headerFilters.school_class, headerFilters.learning_group],
        queryFn: async () => {
            if (canReadTestTaker) {
                const { data } = await getTestTakersOptionsFetch({ ...convertSelectToValue(headerFilters), search: searchTxt, page: 1, pageSize: 15 })
                return data
            }
        },
        staleTime: 1000 * 60 * 5, // המידע נחשב "טרי" ל-5 דקות. הוא לא יקרא לשרת שוב בזמן הזה.
        cacheTime: 1000 * 60 * 30, // שומר את המידע בזיכרון ל-30 דקות
        refetchOnMount: false, // אל תבצע קריאה חדשה רק כי עברנו עמוד והקומפוננטה "עלתה" שוב
        refetchOnWindowFocus: false, // אל תבצע קריאה כשחוזרים לטאב של הדפדפן
        keepPreviousData: true,
        enabled: !!canReadTestTaker
    })

    return (
        <div>
            <AutoComplete
                {...props}
                loading={testTakers.isFetching}
                options={testTakers.data?.results || []}
                onSearchChange={(val) => setSearchTxt(val)}
            />
        </div>
    )
}

export default FilterTestTakers